###
# Тег клиента
###
App.ClientTag = DS.Model.extend
  name            : DS.attr 'string'
  organization    : DS.belongsTo 'organization', async: true
  logistics_center: DS.belongsTo 'logistics-center', async: true

  autoassign            : DS.attr 'boolean'
  autounassign          : DS.attr 'boolean'
  applicable_to_all     : DS.attr 'boolean', defaultValue: true
  tracking_timerange    : DS.attr 'number'

  min_num_of_orders     : DS.attr 'number'
  max_num_of_orders     : DS.attr 'number'
  min_spended_sum       : DS.attr 'number'
  max_spended_sum       : DS.attr 'number'
  min_order_frequency   : DS.attr 'number'
  max_order_frequency   : DS.attr 'number'
  expense_percent       : DS.attr 'number'

  consumed_category     : DS.hasMany 'category',     async: true
  consumed_dish         : DS.hasMany 'dish',         async: true
  non_consumed_category : DS.hasMany 'category',     async: true
  non_consumed_dish     : DS.hasMany 'dish',         async: true
  tags_to_unassign      : DS.hasMany 'clientTag',    async: true

  # Для бонусных категорий
  is_bonus_category             : DS.attr 'boolean'
  bonus_category_color          : DS.attr 'string'
  bonus_category_switch_on      : DS.attr 'boolean'
  bonus_order_sum_period        : DS.attr 'number'
  bonus_order_sum_upper_bound   : DS.attr 'number'
  bonus_category_external_id    : DS.attr 'string'
  bonus_percent                 : DS.attr 'number'


App.ClientTag.reopenClass

  FIXTURES: [
    id   : 1
    name : 'любит печенье'
  ,
    id   : 2
    name : 'добрый'
  ,
    id   : 3
    name : 'особенный'
  ,
    id   : 4
    name : 'в чёрном списке'
  ,
    id   : 5
    name : 'должник'
  ]


# App.ClientTagAdapter = DS.FixtureAdapter
